// Generated by ReScript, PLEASE EDIT WITH CARE

import * as BsCss from "../../../../bindings/BsCss.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as Theme from "../../../../css/Theme.bs.js";

var formInput_ = Curry._1(BsCss.style, {
      hd: BsCss.width(BsCss.pct(100)),
      tl: {
        hd: BsCss.textAlign("left"),
        tl: /* [] */0
      }
    });

var formLabel = Curry._1(BsCss.style, {
      hd: BsCss.display("block"),
      tl: {
        hd: BsCss.fontWeight("semiBold"),
        tl: {
          hd: BsCss.color(Theme.Color.gray800),
          tl: {
            hd: BsCss.textAlign("left"),
            tl: {
              hd: BsCss.fontSize(BsCss.rem(1.25)),
              tl: {
                hd: BsCss.lineHeight(BsCss.px(28)),
                tl: {
                  hd: BsCss.marginTop(BsCss.rem(2)),
                  tl: {
                    hd: BsCss.marginBottom(BsCss.rem(2)),
                    tl: /* [] */0
                  }
                }
              }
            }
          }
        }
      }
    });

var errorTextStyle = Curry._1(BsCss.style, {
      hd: BsCss.display("block"),
      tl: {
        hd: BsCss.textAlign("left"),
        tl: {
          hd: BsCss.fontSize(BsCss.rem(0.75)),
          tl: {
            hd: BsCss.marginBottom(BsCss.rem(0.5)),
            tl: {
              hd: BsCss.marginLeft(BsCss.px(-2)),
              tl: {
                hd: BsCss.color(Theme.Color.prezzeeRed),
                tl: /* [] */0
              }
            }
          }
        }
      }
    });

var tAndCs = Curry._1(BsCss.style, {
      hd: BsCss.selector("a", {
            hd: BsCss.color(Theme.Color.red400),
            tl: {
              hd: BsCss.hover({
                    hd: BsCss.textDecoration("underline"),
                    tl: /* [] */0
                  }),
              tl: {
                hd: BsCss.focus({
                      hd: BsCss.textDecoration("underline"),
                      tl: /* [] */0
                    }),
                tl: /* [] */0
              }
            }
          }),
      tl: /* [] */0
    });

var list = Curry._1(BsCss.style, {
      hd: BsCss.selector("ul", {
            hd: BsCss.important(BsCss.listStyleType("disc")),
            tl: /* [] */0
          }),
      tl: /* [] */0
    });

var phoneInput = "appearance-none rounded-lg border-2 text-gray-800 leading-tight ml-8 py-3 px-3 mb-4 outline-none w-full";

var previousButton = "text-black font-bold float-left mt-10 p-3 text-gray-500 focus:outline-none";

var previousButtonIcon = "mr-5 text-4xl text-gray-500";

var nextButton = "text-black font-bold float-right mt-10 p-3 focus:outline-none";

var nextButtonDisabled = "text-black font-bold float-right mt-10 p-3 text-gray-500 focus:outline-none cursor-not-allowed";

var nextButtonIcon = "ml-2 text-4xl text-prezzee-red";

var submitBtn = "mt-8";

export {
  formInput_ ,
  formLabel ,
  phoneInput ,
  previousButton ,
  previousButtonIcon ,
  nextButton ,
  nextButtonDisabled ,
  nextButtonIcon ,
  errorTextStyle ,
  tAndCs ,
  submitBtn ,
  list ,
}
/* formInput_ Not a pure module */
